var styles = [".main[_ngcontent-%COMP%]{margin-bottom:96px}"];
export { styles as styles };
